document.addEventListener('DOMContentLoaded', function () {
    const buttonSoldOut = document.querySelector('popup-component button');

    function addCloseButton() {
        const clearfix = document.querySelector('.swym-isa-inline-form .clearfix');
        if (clearfix && !document.querySelector('.close-popup')) {
            const closeDiv = document.createElement('div');
            closeDiv.textContent = 'X';
            closeDiv.style.cursor = 'pointer';
            closeDiv.classList.add('close-popup');
            clearfix.appendChild(closeDiv);

            closeDiv.addEventListener('click', function () {
                document.body.classList.remove('show-popup-backInStock');
                closeDiv.remove();
            });
        }
    }

    if (buttonSoldOut) {
        buttonSoldOut.addEventListener('click', function () {
            document.body.classList.add('show-popup-backInStock');
            addCloseButton();
        });
    }

    const remindButtons = [
        document.getElementById('swym-remind-email-auth-button'),
        document.getElementById('remind-me-subscribe-btn')
    ];

    remindButtons.forEach(function (btn) {
        if (btn) {
            btn.addEventListener('click', function () {
                addCloseButton();
            });
        }
    });
});
